import { Patch } from "../http/httpVerbs";

export const apiBulkUpdateVoucherSent = async (ids, isVoucherSent) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/post-rewards/bulk-voucher-sent`;
    const response = await Patch(url, {
      ids,
      isVoucherSent,
    });
    return response;
  } catch (error) {
    console.error("Error updating voucher sent status:", error);
    throw error;
  }
};
